"use strict"
;(() => {

    let expandedCategories = false
    let checkboxesCategories = document.getElementById("checkboxesCategories");
    let categoryOption = document.getElementById("categoryOption");
    let showCheckboxesCategories = document.getElementById("showCheckboxesCategories")

    showCheckboxesCategories.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleExpandOptions();
    });

    showCheckboxesCategories.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            toggleExpandOptions();
        }
    });

    const toggleExpandOptions = () => {
        if (!expandedCategories) {
            checkboxesCategories.style.display = "block";
            categoryOption.style.boxShadow = "0 4px 8px 0 rgba(41, 41, 41, .16)";
            expandedCategories = true;
        } else {
            checkboxesCategories.style.display = "none";
            categoryOption.style.boxShadow = "0 4px 8px 0 rgba(41, 41, 41, .16)";
            expandedCategories = false;
        }
    }


    let allCheckboxes
    let toggleCheck = function (e) {
        e.stopPropagation()
        let clicked = this
        let checked = clicked.checked

        //Handle category parent
        if ("-1" === clicked.dataset.parent) {
            //Search children that are part of this parent
            Array.prototype.slice.call(allCheckboxes).forEach(function (c) {
                if (
                    c.dataset.parent === clicked.id ||
                    clicked.id == "select_all_categories"
                ) {
                    /* set checked state same as clicked ones */
                    c.checked = checked
                }
                if (c.value === clicked.value && c !== clicked) {
                    if (checked) {
                        document.getElementById(
                            "select_all_categories"
                        ).checked = false
                    }
                    c.checked = checked
                }
            })
        } else {
            let parentId = clicked.dataset.parent
            let categorySameId = ""
            Array.prototype.slice.call(allCheckboxes).forEach(function (c) {
                //Search category with the same value
                if (c.value === clicked.value && c !== clicked) {
                    c.checked = clicked.checked
                    categorySameId = c.id
                }
                //search checkboxes having data-parent same as clicked ones and is not checked
                if (parentId === c.dataset.parent && !c.checked) {
                    checked = false
                    return false
                }
            })
            //Look for subcategories after enable/disable all categories
            Array.prototype.slice.call(allCheckboxes).forEach(function (c) {
                if (c.dataset.parent === categorySameId) {
                    c.checked = clicked.checked
                }
            })
            //search parent checkbox of clicked ones
            Array.prototype.slice.call(allCheckboxes).forEach(function (c) {
                if (c.id === parentId) {
                    c.checked = checked
                    return false
                }
            })
        }

        changeOptionTextCategories();
    }

    //Get all the checkboxes with data-parent id and add eventListener
    document.addEventListener("DOMContentLoaded", function () {

        changeOptionTextCategories();

        allCheckboxes = document.querySelectorAll(
            "input[type=checkbox][data-parent][id]"
        )

        allCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("click", toggleCheck)
        })
    })

    document.getElementById("buttonCloseCategory").addEventListener("click", function (event) {
        event.preventDefault()
        event.stopPropagation()
        checkboxesCategories.style.display = "none";
        categoryOption.style.boxShadow = "unset";
        expandedCategories = false;
    });

    document.getElementById("buttonChooseCategory").addEventListener("click", function (event) {
        event.preventDefault()
        event.stopPropagation()
        checkboxesCategories.style.display = "none";
        categoryOption.style.boxShadow = "unset";
        expandedCategories = false;
    });

    document.getElementById("buttonResetCategory").addEventListener("click", function (event) {
        event.preventDefault()
        event.stopPropagation()
        allCheckboxes = document.querySelectorAll("#checkboxesCategories input");

        allCheckboxes.forEach(input => {
            input.checked = false
        });

        changeOptionTextCategories();
    });

    const changeOptionTextCategories = () => {
        allCheckboxes = document.querySelectorAll("#checkboxesCategories input");
        let numChecked = 0
        let numTotal = 0

        allCheckboxes.forEach(input => {
            numTotal++;
            if (input.checked) {
                numChecked++;
            }

        });

        const selectElement = document.getElementById('categoryOption');

        const optionElement = selectElement.querySelector('option');

        const controlsCloseCategory = document.getElementById("controlsCloseCategory")
        const controlsChooseCategory = document.getElementById("controlsChooseCategory")

        let textOption = ""
        if (numChecked == 0) {
            textOption = 'bitte auswählen';
            controlsChooseCategory.style.display = 'none';
            controlsCloseCategory.style.display = 'flex';
        } else {
            textOption = `${numChecked} von ${numTotal} ausgewählt`;
            controlsCloseCategory.style.display = 'none';
            controlsChooseCategory.style.display = 'flex';
        }

        optionElement.textContent = textOption
    }

    document.addEventListener("click", function (event) {
        let targetElement = event.target;

        if (!checkboxesCategories.contains(targetElement)) {
            checkboxesCategories.style.display = "none";
            categoryOption.style.boxShadow = "unset";
            expandedCategories = false;
        }
    });

})()
